<template>
  <div class="ProductDetails">
    <banner title="" :img="require('../assets/img/bgtop1.jpg')"/>
    <div class="ProductDetails-product">
      <div class="ProductDetails-product-content">
        <img v-lazy="newsIdList.imgUrl" alt />
        <p class="product-title">{{newsIdList.title}}</p>
        <p class="product-time">{{newsIdList.createTime}}</p>
        <p class="product-content">{{newsIdList.content}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "ProductDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      newsIdList: {}
    };
  },
  created() {
    this.newsIdList = this.$route.query.cas;
    // window.console.log(this.pid);
  },
  mounted() {
    // this.loadData();
  },
  methods: {
    // loadData() {
    //   this.$http
    //     .get(`News/GetNewsById/${this.pid}`)
    //     .then(response => {
    //       //console.log(response);
    //       this.newsIdList = response.data;
    //       window.console.log(this.newsIdList);
    //     })
    //     .catch(function(error) {
    //       window.console.log(error);
    //     });
    // }
  }
};
</script>

<style lang="scss" scoped>
.ProductDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #f0f0f0;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid  #e4e4e4;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 60px 0;
      }
    }
  }
}
</style>